module.exports = __webpack_public_path__ + "img/manutd2.b7ad189e.jpg";